import React from "react";
import classNames from "classnames";

import { request } from "../../api";

import styles from "./Gallery.module.scss";

const Gallery = ({ className, images, speed = 5000, reverse }) => {
  return (
    <div className={classNames(styles.Gallery, className)}>
      <div className={styles.Container}>
        {[{}, {}].map((_, index) => {
          return (
            <section
              key={index}
              className={classNames(styles.Section, reverse && styles.Reverse)}
              style={{ "--speed": `${speed}ms` }}
            >
              {images.map((image) => (
                <img
                  key={image.id}
                  className={styles.Image}
                  src={`${request}${image.image.url}`}
                  alt={image.id}
                />
              ))}
            </section>
          );
        })}
      </div>
    </div>
  );
};

export default Gallery;
